import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _FrameLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", strokeLinejoin: "round", d: "M8 3v1c0 1.886 0 2.828-.586 3.414S5.886 8 4 8H3M16 3v1c0 1.886 0 2.828.586 3.414S18.114 8 20 8h1M8 21v-1c0-1.886 0-2.828-.586-3.414S5.886 16 4 16H3M16 21v-1c0-1.886 0-2.828.586-3.414S18.114 16 20 16h1" })));
}
const FrameLight = forwardRef(_FrameLight);
export { FrameLight };
